import request from '@/utils/request'

export function fetchApptResults(data) {
  return request({
    url: '/callCenterResults',
    method: 'post',
    data
  })
}
